import { Box } from '@mui/material';

// Components
import Header from './Header';
import SidebarMenu from './SidebarMenu';
import { useQueryUsageInformation } from 'src/services/queries';

export default function Drawer({
  hideSideBar,
  open,
  handleOpen,
}: {
  hideSideBar?: boolean;
  open: boolean;
  handleOpen: (value: boolean) => void;
}) {
  const { data: dataUsage } = useQueryUsageInformation();

  const handleDrawerOpen = () => {
    handleOpen(true);
  };

  const handleDrawerClose = () => {
    handleOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }} className="adamftd-component-not-print">
      <Header dataUsage={dataUsage} open={open} hideSideBar={hideSideBar} />
      {!hideSideBar && (
        <SidebarMenu
          dataUsage={dataUsage}
          open={open}
          handleDrawerOpen={handleDrawerOpen}
          handleDrawerClose={handleDrawerClose}
        />
      )}
    </Box>
  );
}
